export default "__VITE_ASSET__DeCuYgWg__"